import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

    public file = null;
    public creboNumber = null;
    constructor(private http: HttpClient, private snackbar: SemsoSnackbarService) { }

    ngOnInit() {
    }

    update(file) {
        this.file = file;
    }

    public upload(creboNumber: number) {
        this.http.post(`/ImportExport/import/${creboNumber}`, {
            xmlBase64: this.file,
            update: false
        }).subscribe(() => this.snackbar.success('crebo succesvol geupload'), () => 'Fout bij het uploaden van de crebo');
    }

}



// WEBPACK FOOTER //
// ./src/app/crebo-tool/upload/upload.component.ts